// Mock data for the public product / auction page.
// Listing: 1990 Nissan Skyline R32 GT-R — Liberty Walk × Kaido Works "QUADRANT 13"
//
// Same chassis featured on the Build Showcase page; this listing wraps that
// build into an auction format (current bid, reserve, payment + shipping).

export const product = {
  id: 213,
  slug: 'r32-gtr-quadrant',
  buildId: 213, // links into BuildShowcase route
  title: 'Skyline',
  make: 'Nissan',
  model: 'R32 GT-R',
  subModel: 'BNR32 · Liberty Walk × Kaido Works',
  year: 1990,
  buildName: 'LB × KAIDO WORKS — QUADRANT 13',
  modificationStatus: 'SIGNIFICANT',
  comments: 318,
  qa: 24,

  // Auction state
  auction: {
    closesISO: '2026-05-03T13:33:00Z',
    daysRemaining: 2,
    currentBid: 268500,
    bidsCount: 7,
    reserveMet: false,
    quickBidIncrement: 500,
    reserveDisclosure: 'Reserve Not Met',
  },

  // Hero gallery — reuses the existing R32 photoset (already loaded under /r32/).
  // Order optimised for an auction listing (best front 3/4 first, then beauty
  // shots, then detail).
  gallery: [
    { src: '/r32/hero-front-cherry.jpg',     label: 'Front 3/4 · Sakura' },
    { src: '/r32/hero-night-highway.jpg',    label: 'Shutoko · night run' },
    { src: '/r32/hero-rear-3q.jpg',          label: 'Rear 3/4 · GT wing' },
    { src: '/r32/hero-front-garage.jpg',     label: 'Front 3/4 · Garage' },
    { src: '/r32/hero-paddock.jpg',          label: 'Front 3/4 · F1 Paddock' },
    { src: '/r32/hero-warehouse.jpg',        label: 'Front 3/4 · Warehouse' },
    { src: '/r32/hero-sunset-street.jpg',    label: 'Front 3/4 · Sunset' },
    { src: '/r32/detail-side-skirt.jpg',     label: 'Side · #13 livery' },
    { src: '/r32/detail-fender-flare.jpg',   label: 'Fender flare' },
    { src: '/r32/detail-rear-diffuser.jpg',  label: 'Rear · Diffuser' },
    { src: '/r32/detail-rear-wing.jpg',      label: 'Rear · Swan-neck wing' },
    { src: '/r32/detail-front-hood.jpg',     label: 'Front detail · Hood up' },
    { src: '/r32/detail-headlight.jpg',      label: 'Detail · Headlight' },
  ],

  // Highlights grid — 9 stat tiles
  highlights: [
    { key: 'mileage',      label: 'Mileage',       value: '8,420',          unit: 'mi',     icon: 'gauge'        },
    { key: 'horsepower',   label: 'Horse Power',   value: '480',            unit: 'whp',    icon: 'flame'        },
    { key: 'torque',       label: 'Torque',        value: '440',            unit: 'lb-ft',  icon: 'torque'       },
    { key: 'engine',       label: 'Engine',        value: 'RB26DETT',       unit: '',       icon: 'engine'       },
    { key: 'transmission', label: 'Transmission',  value: 'Getrag 5-speed', unit: 'Manual', icon: 'transmission' },
    { key: 'drive',        label: 'Drive Type',    value: 'AWD',            unit: 'ATTESA E-TS', icon: 'drive'   },
    { key: 'extColor',     label: 'Exterior',      value: 'Gloss White',    unit: 'with Quadrant #13 livery', icon: 'paint',  swatch: '#f7f7f7' },
    { key: 'intColor',     label: 'Interior',      value: 'Black + Alcantara', unit: 'Bride Stradia II', icon: 'paint', swatch: '#161618' },
    { key: 'style',        label: 'Style',         value: 'Coupe',          unit: '2-door', icon: 'car'          },
  ],

  seller: {
    name: 'Stan Smith',
    handle: '@stan.builds',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    role: 'Seller · verified builder',
    location: 'Atlanta, Georgia',
    listedSince: 'Listed Apr 23, 2026',
    activeListings: 3,
    rating: 4.9,
    sales: 12,
  },

  shipping: {
    pickupCity: 'Atlanta, Georgia',
    options: [
      {
        title: 'Local Pick-up',
        copy: 'Buyer is responsible for arranging local pick-up.',
        detail: 'Free pick-up at our Atlanta, GA shop. Open weekdays 9am–6pm ET.',
      },
      {
        title: 'beRides Delivery',
        copy: 'Delivered directly from the seller to your selected address.',
        detail: 'Door-to-door enclosed transport. Quote calculator below.',
      },
    ],
  },

  payment: {
    premiumFeePct: 10,
    premiumFeeMin: 225,
    premiumFeeMax: 4500,
    methods: ['bR Escrow', 'Wire Transfer', 'Visa', 'Mastercard', 'Amex', 'Discover'],
  },

  keySellingPoints: [
    'Hand-built at Liberty Walk Nagoya HQ — full Kaido Works FRP wide aero kit',
    'RB26DETT refreshed with forged internals + Tomei ARMS M7960 twin-scroll turbos',
    'Tuned on E85 — 480 whp / 440 lb-ft on a Mustang AWD dyno',
    'SSR Professor SP4 18×10/18×11 wrapped in Yokohama Advan A052',
    'Endless Mono 6R 6-pot front BBK + braided lines + RBF660 fluid',
    'Quadrant Team #13 livery (Liqui Moly, BLASK, AK-Produce, Tone, Bride sponsors)',
    'Bride Stradia II buckets + bolt-in JAF-spec roll cage',
  ],

  details: [
    { k: 'Condition',                      v: 'Show + driven · always garaged' },
    { k: 'Horse Power',                    v: '480 whp' },
    { k: 'Title in Seller name?',         v: 'Yes' },
    { k: 'Vehicle Segment',                v: 'JDM · Kaido Racer' },
    { k: 'Year',                           v: '1990' },
    { k: 'Name on the Title',              v: 'Stan Smith' },
    { k: 'VIN',                            v: 'BNR32-008412' },
    { k: 'Mileage',                        v: '8,420 mi · build odometer' },
    { k: 'State of the Title',             v: 'Georgia' },
    { k: 'Torque',                         v: '440 lb-ft' },
    { k: 'Transmission',                   v: 'Getrag 5-speed manual' },
    { k: 'Status of the Title',            v: 'Clean · zero accidents' },
    { k: 'Drivetrain',                     v: 'ATTESA E-TS AWD (rear-biased)' },
    { k: 'Curb Weight',                    v: '3,150 lbs' },
    { k: 'Fuel',                           v: 'E85 primary · 100 oct fallback' },
    { k: 'Service interval',               v: '5,000 mi · oil + plugs' },
  ],

  conditionReport: [
    'Paint inspected at Liberty Walk HQ — single panel polish, no body filler',
    'Original VIN tag intact · matching numbers verified by Skyline Specialists Atlanta',
    'No accident history · pre-purchase inspection on file (Apr 18, 2026)',
    'Engine compression test 165 psi across all 6 cylinders (within 4 psi)',
    'Fresh service: oil, plugs, valve clearances, transmission oil — Mar 2026',
  ],

  recentBids: [
    { user: 'Bidder #41', amount: 268500, when: 'Apr 30, 2026 · 10:59 AM ET' },
    { user: 'Bidder #28', amount: 265000, when: 'Apr 30, 2026 · 09:02 AM ET' },
    { user: 'Bidder #12', amount: 260000, when: 'Apr 29, 2026 · 06:14 PM ET' },
    { user: 'Bidder #07', amount: 252000, when: 'Apr 29, 2026 · 02:48 PM ET' },
    { user: 'Bidder #03', amount: 245000, when: 'Apr 28, 2026 · 11:30 AM ET' },
  ],

  faqs: [
    {
      q: 'How does bidding work?',
      a: 'Set your maximum bid and we will auto-bid in the smallest increment necessary up to that amount. You will only pay the lowest amount required to win.',
    },
    {
      q: 'Bid increment table',
      a: 'Bids 100–14,999 USD increment by 100. 15,000–49,999 by 250. 50,000+ by 500.',
    },
    {
      q: 'What is the bR Premium Fee?',
      a: '10% of the final winning bid (min $225 / max $4,500), charged at auction close.',
    },
  ],

  similar: [
    { id: 1, title: 'BNR34 GT-R · Mine\'s Tribute',     bid: 142000, image: '/r32/hero-paddock.jpg',        location: 'Tokyo' },
    { id: 2, title: 'Pandem Rocket Bunny S15',          bid: 84000,  image: '/r32/hero-warehouse.jpg',      location: 'Yokohama' },
    { id: 3, title: 'Liberty Walk RX-7 FD3S',           bid: 96500,  image: '/r32/hero-sunset-street.jpg',  location: 'Osaka' },
  ],
};

export const usd = (n) =>
  `$${Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
